module.exports = __webpack_public_path__ + "img/security-1.ffb02b87.png";